import React, { forwardRef } from "react";
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";
import { EmailIcon, FacebookIcon, LinkedinIcon, XIcon } from "react-share";
import IStyledProps from "../../utilities/IStyledProps";
import IEditableProps from "../../utilities/IEditableProps";
import classNames from "classnames";
import { useTheme } from 'styled-components';

export interface IShareButtonProps extends IEditableProps, IStyledProps {
    url: string;
    size: number;
    round: boolean;
    gutterClass: string;
}

const ShareButtons = forwardRef(({ url, size, round, gutterClass = "", cmsId, editorClassObj }: IShareButtonProps, ref: any) => {
    const theme = useTheme();
    return (
        <span className={classNames(editorClassObj)} ref={ref} data-id={cmsId}>
            <FacebookShareButton url={url} className={gutterClass}>
                <FacebookIcon size={size} round={round} />
            </FacebookShareButton>
            <TwitterShareButton url={url} className={gutterClass}>
                <XIcon size={size} round={round}/>
            </TwitterShareButton>
            <LinkedinShareButton url={url} className={gutterClass}>
                <LinkedinIcon size={size} round={round} />
            </LinkedinShareButton>
            <EmailShareButton url={url}>
                <EmailIcon size={size} round={round} bgStyle={{ fill: theme.primary }} />
            </EmailShareButton>
        </span>
    );
});

export default ShareButtons;